const VERIFY_CUSTOMER_EMAIL_API_URL = 'https://phpstack-1018833-4127515.cloudwaysapps.com/checkcustomernew.php';

document.addEventListener('alpine:init', () => {
  // handle pill buttons action
  Alpine.data('pillButtons', () => ({
    init() {
      // Check if the URL has the filter.p.product_type parameter
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('filter.p.product_type')) {
        // If not present, clear the selected pill button data
        window.sessionStorage.removeItem('LIF-PARAM--SELECTED_PILL_BUTTON');
      }

      window.sessionStorage.setItem('LIF-PARAM--CURRENT_PAGE_URL', window.location.href);
    },
    filter(productTypes, index) {
      window.sessionStorage.setItem('LIF-PARAM--SELECTED_PILL_BUTTON', index);

      let queryString = "?filter.p.product_type=" + productTypes;

      const existingParams = window.location.search.substring(1).split('&'); // Includes the "?" character
      if (existingParams.length > 0) {
        for(const param of existingParams) {
          if (!param.startsWith('sort_by=') && !param.startsWith('filter.')) {
            queryString += "&" + param;
          }
        }
      }
      
      window.location.href = queryString;
    },
    get selectedPillButtonIndex() {
      return window.sessionStorage.getItem('LIF-PARAM--SELECTED_PILL_BUTTON');
    }
  }));

  Alpine.data('collectionFilter', () => ({
    fllterOpen: false,
    totalResultCount: null,
    selectedSortBy: null,
    selectedSortByName: "Featured",
    showFilterModal: false,
    selectedFilterNames: [],
    priceFilterValues: [],
    
    init() {

      this.updateProductCount();
      
      Alpine.store('URL').queryParams.forEach((param) => {
        if (param[0] == 'sort_by') {
          this.selectedSortBy = param[1];

          if (this.selectedSortBy == 'price-ascending' || this.selectedSortBy == 'price-descending') {
            this.loadAllPages(() => {
              setTimeout(() => {
                // Sort by client side
                this.orderTilesByPrice();  
              }, 2000); // Let's load price element
            });
          }
        }
      });

      this.$watch('fllterOpen', (isOpen) => {
        console.log('fllterOpen changed...');
        console.log(isOpen);
        Alpine.store('screen').isScrollableBody = !isOpen;
      }); 

      Alpine.nextTick(() => {
        // Reinitialize Alpine refs and behaviors if needed
        this.updateSelectedFilterNames();
      });
    },

    updateSelectedFilterNames() {
      Alpine.initTree(document.querySelector('#filter_flyout'));
      this.selectedFilterNames = [];

      // Re-select the form after DOM has been updated
      const filterForm = document.querySelector('[x-ref="filterForm"]');
      if (!filterForm) return;

      const checkedFilters = filterForm.querySelectorAll('input[type="checkbox"]:checked');
      checkedFilters.forEach((input) => {
        const label = input.nextElementSibling?.innerText.trim() || input.dataset.label.trim() || input.value.trim();
        this.selectedFilterNames.push({ 
          label,
          data: {
            name: input.name, 
            value: input.value 
          }
        });
      });

      const params = new URLSearchParams(window.location.search);
      const paramMinPrice = params.get('filter.v.price.gte');
      const paramMaxPrice = params.get('filter.v.price.lte');

      if (paramMinPrice && paramMaxPrice) {
        this.selectedFilterNames.push({ 
          label: `Price: Min ${paramMinPrice}, Max ${paramMaxPrice}`,
          data: { name: 'price',  value: '' }
        });
      }

      // Default values are full range
      this.priceFilterValues = (paramMinPrice && paramMaxPrice) ? [paramMinPrice, paramMaxPrice] : [minPrice, maxPrice];


      console.log(this.selectedFilterNames);
    },

    updateProductCount() {
      this.totalResultCount = null;
      // fetch total customized product count
      const urlConnector = window.location.href.includes('?') ? '&' : '?';
      fetch(window.location.href+urlConnector+'view=products-count')
      .then(response => response.text())
      .then(count => {
        this.totalResultCount = parseInt(count.trim());
      })
    },

    async applyFilter(formRef = null, removeFilter = null) {
      // console.log('applyFilter...');
      // this.$refs.filterForm.submit();

      try {
        let formData = new FormData(formRef ? this.$refs[formRef] : this.$refs.filterForm);

        if (!formData && !this.$refs.filterForm) {
          const filterForm = document.querySelector('[x-ref="filterForm"]');
          formData = new FormData(filterForm)
        }

        // Convert to a query string
        const searchParams = new URLSearchParams(formData);
        const uniqueSearchParams = {};

        for (const [key, value] of searchParams) {

          console.log(removeFilter);

          // check if filter to remove
          if (removeFilter && (removeFilter.name == 'ALL' || (removeFilter.name == 'price' && key.includes('filter.v.price.')) || (key == removeFilter.name && value == removeFilter.value))) {
            // Skip filter to remove
            continue;
          }

          if (uniqueSearchParams.hasOwnProperty(key)) {
            // Make comma seperated muitlple values
            uniqueSearchParams[key] = `${uniqueSearchParams[key]},${value}`;
          } else {
            uniqueSearchParams[key] = value;
          }
        }

        this.selectedSortBy = uniqueSearchParams.sort_by;
        const hasNewSort = Object.keys(uniqueSearchParams).includes('sort_by');
        const hasNewFilter = Object.keys(uniqueSearchParams).find(p => p.startsWith('filter.'));
        const hasEmptyFilter = Object.keys(uniqueSearchParams).length == 0;

        let queryString = Object.keys(uniqueSearchParams).map(k => `${k}=${uniqueSearchParams[k]}`).join('&');
        // console.log(queryString);

        const existingParams = window.location.search.substring(1).split('&'); // Includes the "?" character
        if (existingParams.length > 0) {
          for(const param of existingParams) {

            if (param.startsWith('page=')) {
              continue;
            }

            const hasExistingSort = param.startsWith('sort_by=');
            const hasExistingFilter = param.startsWith('filter.');

            if ((!hasExistingSort && !hasExistingFilter) || (hasExistingSort && !hasNewSort) || (hasExistingFilter && !hasNewFilter && !hasEmptyFilter)) {
              if (queryString) {
                queryString += "&" + param;
              } else {
                queryString = param;
              }
            }
          }
        }

        console.log(queryString);

        const baseURL = window.location.origin + window.location.pathname;
        const searchURL = `${baseURL}?${queryString}`;
        window.history.replaceState(queryString, document.title, searchURL);

        if (uniqueSearchParams.sort_by) {
          if (uniqueSearchParams.sort_by == 'price-ascending' || uniqueSearchParams.sort_by == 'price-descending') {

            this.selectedSortBy = uniqueSearchParams.sort_by;

            if (Alpine.store('collection').hasNextPage) {
              this.loadAllPages(() => {
                setTimeout(() => {
                  // Sort by client side
                  this.orderTilesByPrice();  
                }, 2000); // Let's load price element
              });
            } else {
              this.orderTilesByPrice();
            }

            return;
          }
        }

        this.updateProductCount();

        const response = await fetch(searchURL);
        const res = await response.text();

        // Initialize the DOM parser
        var parser = new DOMParser();

        // Parse the text
        const doc = parser.parseFromString(res, "text/html");

        // Fetch page content and pagination content from page result
        const newContainer = doc.querySelector('#product_grid');
        const newFilter = doc.querySelector('#filter_flyout');
        const newPagination = doc.querySelector('#product_pagination');
        const newTotalResult = doc.querySelector('#total_result_count');
        const newSorting = doc.querySelector('#sorting_flyout');

        const errorContainer = document.querySelector('#collection_error_container');
        const cardContainer = document.querySelector('#product_grid');

        // Render page content to end of the page
        if (newContainer) {
          const alwaysOnTopItems = document.querySelectorAll('.product-card-always-on-top');
          if (alwaysOnTopItems.length > 0) {
            const lastAlwaysOnTop = alwaysOnTopItems[alwaysOnTopItems.length - 1];

            // Append elements after "Always on top" elements
            cardContainer.querySelectorAll('.collection-product-tile').forEach(el => el.remove());
            lastAlwaysOnTop.insertAdjacentHTML('afterend', newContainer.innerHTML);
          } else {
            cardContainer.innerHTML = newContainer.innerHTML;
          }
          if (errorContainer) {
            errorContainer.innerHTML = '';
          }
        } else {
          document.querySelector('#product_grid').innerHTML = '';

          if (errorContainer) {
            errorContainer.innerHTML = 'No products found. Use fewer filters or remove all.';
          }
        }

        if (newFilter) {
          document.querySelector('#filter_flyout').innerHTML = newFilter.innerHTML;
        }

        if (newSorting) {
          document.querySelector('#sorting_flyout').innerHTML = newSorting.innerHTML;
        }

        if (newPagination) {
          document.querySelector('#product_pagination').innerHTML = newPagination.innerHTML;
        }

        // document.querySelectorAll('.collection__total-items').forEach((e) => {
        //   const totalResult = newTotalResult.innerHTML;
        //   const itemText = totalResult > 1 ? 'Items' : 'Item';
        //   e.innerHTML = `${totalResult} ${itemText}`;
        // });

        // this.totalResultCount = newTotalResult.innerHTML;
        Alpine.store('collection').hasNextPage = true;

        // Alpine.store('collection').loadFirstProduct();

        // loadPages defined in products-pagination.js (calling parent method)

        if (this.loadPages) {
          this.currentPage = 1;
          this.loadPages(queryString);
        }

        Alpine.nextTick(() => {
          this.updateSelectedFilterNames();
        });

      } catch (e) {
        console.error(e);
      }
    },

    orderTilesByPrice() {
      const tileElements = document.querySelectorAll('li.collection-product-tile');
      for(const tileElement of tileElements) {
        const priceElement = tileElement.querySelector('.product-tile-price');
        if (priceElement) {
          const price = (parseFloat(priceElement.innerHTML.split('$')[1]) * 100).toFixed();
          tileElement.style.order = this.selectedSortBy == 'price-descending' ? (-1) * price : price;
        }
      }
    }
  }));

  // Extending collectionFilter
  Alpine.data('explorationFilter', (activeMenuIndexes, minPrice, maxPrice) => ({
    openedFilterMenuIndexes: activeMenuIndexes,
  
    init() {

      const params = new URLSearchParams(window.location.search);
      const paramMinPrice = params.get('filter.v.price.gte');
      const paramMaxPrice = params.get('filter.v.price.lte');

      // Default values are full range
      this.priceFilterValues = (paramMinPrice && paramMaxPrice) ? [paramMinPrice, paramMaxPrice] : [minPrice, maxPrice];

      const priceSlider = this.$refs.price_slider;

      if (priceSlider) {
        noUiSlider.create(priceSlider, {
          start: this.priceFilterValues,
          connect: true,
          step: 1,
          range: {
            'min': minPrice,
            'max': maxPrice
          },
          tooltips: true,
          format: {
            to: function (value) {
              return Math.round(value);
            },
            from: function (value) {
              return Number(value);
            }
          }
        });

        const minPriceDisplay = document.getElementById("min-price");
        const maxPriceDisplay = document.getElementById("max-price");

        priceSlider.noUiSlider.on('update', (values) => {
          minPriceDisplay.textContent = values[0];
          maxPriceDisplay.textContent = values[1];
        });

        priceSlider.noUiSlider.on('change', (values) => {
          this.priceFilterValues = values;
        });
      }
    },

    toggleMenu(index) {
      if (this.openedFilterMenuIndexes.includes(index)) {
        const itemIndex = this.openedFilterMenuIndexes.indexOf(index);

        if (itemIndex > -1) {
          this.openedFilterMenuIndexes.splice(itemIndex, 1);
        }
      } else {
        this.openedFilterMenuIndexes.push(index);
      }
    },
    
  }));

  // Handle mobile - sticky add-to-cart button
  Alpine.data('stickyAddToCart', () => ({
    init() {
      window.addEventListener('scroll', this.handleScroll);
    },
    handleScroll() {
      const buyButtons = document.querySelector('.pdp-add-to-cart-button');
      const stickyButton = document.getElementById('sticky-add-to-cart');

      if (buyButtons) {
        const rect = buyButtons.getBoundingClientRect();

        if (rect.top < -buyButtons.offsetHeight && Alpine.store('cart').isSideCartOpen === false) {
          stickyButton.style.display = 'block'; // Show sticky button
        } else {
          stickyButton.style.display = 'none'; // Hide sticky button
        }
      }
    }
  }));

  Alpine.data('shopSimilar', () => ({
    showModal: false,
    products: [],
    product: null,
    hasProducts: true,

    init() {
      this.product = JSON.parse(document.getElementById('product-json').textContent);
      this.fetchProducts();
      this.fetchAndAppendImages();

      this.$watch('showModal', (isShow) => {
        Alpine.store('screen').isScrollableBody = !isShow;
      });
    },

    async fetchProducts() {
      const tags = this.product.tags;
      const styleGroupTag = tags.find(tag => tag.startsWith('_style-group::'));

      if (!styleGroupTag) {
        console.log('No style group tag found.');
        return;
      }

      // console.log('style group tag found.');
      // console.log(styleGroupTag);
      
      const styleGroupNumber = styleGroupTag.split('::')[1];
      try {
        const response = await fetch(`/collections/all/_style-group::${styleGroupNumber}?view=products_by_style_grid`);
        const data = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const productGrid = doc.querySelector('#product_grid');
        let countProducts = 0;

        if (productGrid) {
          const items = productGrid.querySelectorAll('li');
          const flickitySlider = this.$el.querySelector('.carousel');
          const mobileModal = this.$el.querySelector('.shop-similar-mobile-modal');
          
          if (items.length === 0) {
            this.hasProducts = false;
            return;
          }

          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const titleElement = item.querySelector('.card-item-title');
            if (!titleElement) {
              continue; // Skip this iteration
            }

            const itemTitle = titleElement.innerHTML;

            if (this.product.title === itemTitle) {
              continue; // Skip this iteration
            }

            countProducts++;
            const tempContainer = document.createElement('div');
            // Create a temporary container
            tempContainer.innerHTML = item.innerHTML;

            // Select the second child element from tempContainer
            const secondChild = tempContainer.children[1];

            // If the second child exists, set it as the innerHTML of tempContainer
            if (secondChild) {
                tempContainer.innerHTML = secondChild.outerHTML;
            }

            // Now tempContainer contains only the second child
            const childElements = tempContainer.children; 

            Array.from(childElements).forEach(child => {
              child.style.width = '25%';
              child.style.marginRight = '0.5rem';
              flickitySlider.appendChild(child);
              let imgElement = child.querySelector("img.product-tile-image");

              // Add the 'w-auto' class to the image element
              if (imgElement) {
                imgElement.classList.add('!w-auto');
                imgElement.classList.add('!h-auto');
              }
            });

            const mobileItem = document.createElement('div');
            mobileItem.innerHTML = item.innerHTML;
            mobileModal.appendChild(mobileItem);
          }

          if (countProducts <= 4) {
            setTimeout(() => {
              new Flickity('.carousel', {
                fade: true,
                imagesLoaded: true,
                contain: true,
                pageDots: false,
                cellAlign: 'left',
                draggable: false,
                groupCells: false,
                wrapAround: false,
              });
            }, 50);
          } else {
            setTimeout(() => {
              new Flickity('.carousel', {
                fade: true,
                imagesLoaded: true,
                contain: true,
                pageDots: false,
                cellAlign: 'left',
                groupCells: false,
                wrapAround: false,
              });
            }, 50);
          }
          setTimeout(() => {
            if (countProducts <= 4) {
              // Hide Flickity navigation buttons
              const flickityButtons = flickitySlider.querySelectorAll('.flickity-button');
              flickityButtons.forEach(button => {
                button.classList.add('hidden');
              });
            }
          }, 100);      
        } else {
          this.hasProducts = false;
        }
        console.log('countProducts:', countProducts);
        if (countProducts === 0) {
          this.hasProducts = false;
          return;
        }
      } catch (error) {
        console.error('Error fetching the products:', error);
        this.hasProducts = false;
      }
    },

    async fetchAndAppendImages() {
      try {
        const tags = this.product.tags;
        const styleGroupTag = tags.find(tag => tag.startsWith('_style-group::'));

        if (!styleGroupTag) {
          console.log('No style group tag found.');
          this.hasProducts = false;
          return;
        }

        const styleGroupNumber = styleGroupTag.split('::')[1];
        const response = await fetch(`/collections/all/_style-group::${styleGroupNumber}?view=products_by_style_json`);
        const products = await response.json();
        const gridContainer = this.$el.querySelector('.gridContainer');
        let appendedCount = 0;

        if (products.length === 0) {
          this.hasProducts = false;
          return;
        }

        products.forEach(relatedProduct => {
          if (appendedCount >= 4) return;
          if (this.product.id === relatedProduct.id) return;

          if (relatedProduct.images && relatedProduct.images.length > 0) {
            const firstImage = relatedProduct.images[0];
            const imgElement = document.createElement('img');
            imgElement.setAttribute('src', firstImage.src);
            imgElement.setAttribute('alt', firstImage.alt || '');
            imgElement.setAttribute('width', firstImage.width || 100);
            imgElement.setAttribute('height', firstImage.height || 100);
            imgElement.classList.add('product-tile-image', 'relative', 'object-cover', 'aspect-square', 'cursor-pointer');
            gridContainer.appendChild(imgElement);
            appendedCount++;
          }
        });

        if (appendedCount === 0) {
          this.hasProducts = false;
        }
      } catch (error) {
        console.error('Error fetching or parsing the JSON data:', error);
        this.hasProducts = false;
      }
    },
  }));

  Alpine.data('productTile', (productHandle, cardIndex, atcRedirect, restrictPDP) => ({
    product: null,
    mainImage: null, 
    showSvg: false, 
    cardIndex: cardIndex, 
    showOptionSelection: false, 
    quickAddIndex: null,
    shouldProductImageShow: false,
    optionIndex: {},
    isProductDODLimt1: false,
    isSingleVariantProduct: false,
    selectedOptions: {},
    openSizeChart: false,
    selectedVariantColorCode: null,
    variantInverseColor: null,
    specialTagBadges: [],
    isSubscriptionApplicable: false,
    init() {

      // Instance load product 
      try {

        if (productHandle.product) {
          this.product = productHandle.product;
        } else if (this.fwpProduct) {
          this.product = this.fwpProduct;
        } else {
          this.product = JSON.parse(document.querySelector('#product_'+productHandle+'[type="application/json"]').textContent);
        }

        // Hide " - #" suffix from product titles of Kit products
        this.product.title = this.cleanKitProductTitle(this.product.title);

        for (option of this.product.options) {
          const optionName = option.name.toLowerCase();
          this.optionIndex[optionName] = option.position - 1;

          // Check if only one option value is available, then keep selected
          if (option.values.length == 1) {
            this.selectedOptions[option.position] = option.values[0];
          } else {
            this.selectedOptions[option.position] = null;
          }
        }

        // Set initial value of color
        // this.selectedColor = this.product.options[this.optionIndex.color] ? this.product.options[this.optionIndex.color].values[0] : null;

        if (this.optionIndex.color) {
          const colorIndex = this.optionIndex.color;
          this.selectedOptions[colorIndex + 1] = this.product.options[colorIndex].values[0];
        }

        // if (this.optionIndex.style !== undefined) {
        //   this.selectedStyle = this.product.options[this.optionIndex.style] ? this.product.options[this.optionIndex.style].values[0] : null;
        // }

        this.mainImage = this.product.image;
        this.isProductDODLimt1 = !!this.product.tags.find((t) => t.toLowerCase() == 'dod-limit-1');

        this.isSingleVariantProduct = this.product.options.length == 1 && this.product.variants.length == 1;

        // Select first available variant if fwpProduct popup
        if (this.fwpProduct) {
          const firstAvaibleVariant = this.product.variants.find(v => v.remaining_quantity > 0 || v.inventory_policy == 'continue');

          // Select this variant
          for(optionIndex of Object.keys(this.selectedOptions)) {
            this.selectedOptions[optionIndex] = firstAvaibleVariant[`option${optionIndex}`];
          }
        }

        // Mobile: Quick-add should auto-select the first available variant
        const firstAvailableVariant = this.product.variants.find(v => v.remaining_quantity > 0 || v.inventory_policy == 'continue');
        const positions = this.product.options.map(o => o.position);

        for (const position of positions) {
          this.selectedOptions[position] = firstAvailableVariant[`option${position}`];
        }

        // set special tag badges
        this.specialTagBadges = window.__LIF__.special_product_badges.filter(b => this.product.tags.includes(b.product_tag));
      
      } catch(error) {
        console.error(error);
      };

      // Dynamic load product  -- Had performance issue
      // fetch(`/products/${productHandle}.json`)
      // .then((r) => r.json())
      // .then((r) => {
      //   this.product = r.product;
      //   this.selectedColor = this.product.options[1] ? this.product.options[1].values[0] : null;
      //   this.mainImage = this.product.image.src;
      // })
      // .catch((error) => {
      //   console.error(error);
      // });

      this.$watch('quickAddIndex', (index) => {
        Alpine.store('screen').isScrollableBody = index === null;
      });
    },

    setSelectedVariantColorCode(colorCode) {
      this.selectedVariantColorCode = colorCode;

      const color = colorCode.replace('#', '');
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);

      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      this.variantInverseColor = brightness < 128 ? '#fff' : '#000';
    },

    onImageLoaded() {
      // setTimeout(() => {
        this.shouldProductImageShow = true;
      // }, 1000);
    },
    get restrictPDPRedirect() {
      const { offerCollections } = Alpine.store('offer1Free');
      const { baseURL } = Alpine.store('URL');
      
      const { hasSecondProduct, saleDetails } = Alpine.store('fwpOffer');
      const thisCollection = window.location.origin + window.location.pathname;
      if (!hasSecondProduct && saleDetails && saleDetails.targetCollection == thisCollection) {
        return true;
      }

      return restrictPDP || window.__LIF__.restrictPDPRedirect || (offerCollections && offerCollections.includes(baseURL));
    },
    gotoPDP(link) {
      // Check if offer 1 free and PDP not allowed
      if (this.restrictPDPRedirect) {
        this.quickAddIndex = this.cardIndex; 

        if (this.showCompleteLookModal) {
          this.showCompleteLookModal = false;
          this.openSideCartOnClose = true;
        }
      } else {
        window.location.href = link;
      }
    },
    closeMobileQuickAdd() {
      this.quickAddIndex = null;
      if (this.openSideCartOnClose) {
        this.openSideCartOnClose = false;
        Alpine.store('cart').isSideCartOpen = true;
      }
    },
    get PLPImageWidth() {
      return Alpine.store('screen').isMobile ? 400 : 800;
    },

    get shouldShowEdd() { // Check if Estimated Delivery Date should show

      if (!Alpine.store('edd')) {
        return false;
      }
      
      const { hideEddProductTags, hideEddVendors } = Alpine.store('edd').eddSettings;
      
      const hasHideEddTag = hideEddProductTags.some((t) => this.product.tags.includes(t));
      const hasHideEddVendor = hideEddVendors.includes(this.product.vendor);

      return !hasHideEddTag && !hasHideEddVendor;
    },

    get selectedVariant() {

      if (!this.product) {
        return null;
      }

      let variant = null;

      if (this.isSingleVariantProduct) {
        variant = this.product.variants[0];
      } else {

        variant = this.product.variants.find((v) => {
            let matched = true;
            for (let optionPosition in this.selectedOptions) {
              if (this.selectedOptions.hasOwnProperty(optionPosition)) {
                if (v['option'+optionPosition] != this.selectedOptions[optionPosition]) {
                  matched = false;
                }
              }
            }

            return matched;
        });
      }

      return variant;
    },
    get compareAtPrice() {
      if (!this.product) {
        return null;
      }

      const selectedVariant = this.selectedVariant ?? this.product.variants[0];
      return Alpine.store('currency').formatCartMoney(selectedVariant.compare_at_price);
    },
    get variantPrice() {
      if (!this.product) {
        return null;
      }

      const selectedVariant = this.selectedVariant ?? this.product.variants[0];
      return Alpine.store('currency').formatCartMoney(selectedVariant.price);
    },
    get isSelectedVariantOOS() {
      if (!this.selectedVariant) {
        return false;
      }

      return this.selectedVariant.remaining_quantity <= 0 && this.selectedVariant.inventory_policy != 'continue';
    },
    get variantInventoryQty() {
      if (!this.selectedVariant) {
        return 0;
      }

      return this.selectedVariant.remaining_quantity;
    },
    async addToCart(saleData) {

      if (!this.selectedVariant) {
        console.log('Selected variant not existing.');
        return;
      }

      if (Alpine.store('sale').refreshOnATC) {
        // Refresh cart items to get latest cart details to avoid multi tab issue
        Alpine.store('cart').isSideCartOpen = true;
        Alpine.store('cart').isCartInProgress = true;
        await Alpine.store('cart').loadItems();
      }

      const { 
        cartItems,
        shouldApplyMembershipDiscount, 
        hasFreeProduct,
        hasFixedPriceOffer,
        hasBundleItem,
        hasAbsoluteFreeProduct,
        removeMultipleItems,
      } = Alpine.store('cart');

      // Check for item sale property
      let properties = {};
      let bundleItem = null;
      // properties.__member_discount_percentage = saleData.memberDiscount.percentage;
      properties.__member_discount_price = saleData.memberDiscount.price;

      if (Alpine.store('edd')) {
        // Capture EDD onto the line item ONLY when the EDD is actually being
        // shown to the customer (`shouldHide` covers hide-EDD tags, vendors,
        // and POD rules at both the product and cart level). Skipping the
        // write here keeps the property off the order/email confirmation for
        // POD-style purchases and prevents a stale EDD lingering on the line
        // item after the POD-driven hide reason clears.
        const { eddDateText, daysInTransit, shouldHide, eddSettings } = Alpine.store('edd');
        if (eddDateText && daysInTransit && !shouldHide) {
          properties.__estimated_delivery_date = eddDateText;
        }

        const { hideEddProductTags, hideEddVendors, hideEddOnPodProducts } = eddSettings;

        if (this.product.tags && Array.isArray(this.product.tags)) {
          if (hideEddProductTags.some((t) => t && this.product.tags.includes(t))) {
            properties.__is_hide_edd = true;
          }
        }

        if (this.product.vendor && hideEddVendors.includes(this.product.vendor)) {
          properties.__is_hide_edd = true;
        }

        const POD_REGEX = /POD:? /i;
        const isPodType = (typeStr) => POD_REGEX.test(typeStr || '');

        if (hideEddOnPodProducts && isPodType(this.product.product_type)) {
          properties.__is_hide_edd = true;
        }

        properties.__edd_settings = eddSettings;
      }

      if (Alpine.store('buyMoreSaveMoreOffer').isActive) {
        properties.__buy_more_bundle_item = { 
          buyMoreDiscounts: Alpine.store('buyMoreSaveMoreOffer').buyMoreDiscounts,
          saleName: 'Buy More Save More'
        };
      }

      const {
        settings: bundleSettings, // settings of active bundle sale in case of multiple bundle sale active
        isCompleted: isBundleCompleted,
        includedBundleComponents,
        manualActiveIndex,
        thisSaleDetails: bundleSaleDetails, // sale details of active bundle sale in case of multiple bundle sale active
      } = Alpine.store('customBundle');
      const { saleName, saleKey, componentIndex } = saleData.customBundle;

      if ((saleData.applicableSale == LifSale.OFFER_1_FREE || this.fwpProduct) && !hasFreeProduct) {
        const oneFreeProperties = {
          _is_free_shirt: true,
          _applied_offer_type: this.fwpProduct ? 'fwp' : 'Offer 1 Free',
          _free_theshold: window.__LIF__.free_product_threshold,
        }

        if (this.fwpProduct) {
          oneFreeProperties._fwp_first_product = true;
        }

        properties = { ...properties, ...oneFreeProperties };
      } else if (saleData.applicableSale == LifSale.OFFER_FIXED_PRICE && !hasFixedPriceOffer) {
          const fixedPriceProperties = {
            __fixed_price_offer: true,
            _applied_offer_type: '$5 Sweatshirt',
            _free_theshold: window.__LIF__.offer_fixed_price_settings.price_threshold,
          }
  
          properties = { ...properties, ...fixedPriceProperties };
      } else if (!hasAbsoluteFreeProduct && bundleSettings && saleKey && bundleSettings[saleKey].isActive) { 

        const bundleItemIndex = componentIndex ? componentIndex : 0;

        if(!isBundleCompleted[saleKey]) {
            const customBundleSaleProperties = {
              __winter_bundle_sale: { componentIndex : bundleItemIndex, productType: "", saleName, saleKey },
              _offer_limit_one_key: `custom-bundle-${saleKey}-${bundleItemIndex}` // This void to add same bundle index multiple times by checkout ext.
            }
            
            const { thisSettings, bundleKeyProducts } = Alpine.store('customBundle');

            // Check if bundle item is added
            if (!bundleKeyProducts[saleKey]) {
              bundleItem = {
                id: thisSettings.bundleProduct.variants[0].id,
                quantity: 1,
                properties: { 
                  __is_winter_product: true,
                  saleKey, // Add sale key to identify spcific sale in case multiple bundle sale is active
                },
              }
            }

            // Check if free product in cart
            if (hasAbsoluteFreeProduct) {
              const absoluteFreeProduct = cartItems.find((item) => item.properties.attributes && item.properties.attributes._is_absolute_free_product);

              // Delete Free Product
              if (absoluteFreeProduct) {
                await removeMultipleItems([absoluteFreeProduct.key]);
              }
            }

            properties = { ...properties, ...customBundleSaleProperties };
          

          // Allow to auto select filter after adding bundle item
          if (manualActiveIndex !== null) {
            Alpine.store('customBundle').manualActiveIndexCompleted = true;
          }
        } else if (saleData.applicableSale == LifSale.CUSTOM_BUNDLE) {
          const customBundleSaleProperties = {
            __winter_bundle_sale_fixed_price: { 
              type: 'FIXED', 
              price: parseFloat(saleData.customBundle.salePriceValue) * 100,
              saleName
            }
          }

          properties = { ...properties, ...customBundleSaleProperties };
        }
      } else if (saleData.applicableSale == LifSale.DYNAMIC_SALE) {
        const { saleTag, saleName, matchedProductTag, salePriceValue } = saleData.dynamicSale;
        const dynamicSaleProperty = {
          __dynamic_sale_tag: saleTag,
          __dynamic_sale_name: saleName,
          __tags: [matchedProductTag],
        }

        console.log(`salePriceValue: ${salePriceValue}`);
        console.log(`memberDiscountedPrice: ${saleData.memberDiscount.price}`);

        if (!shouldApplyMembershipDiscount || !saleData.memberDiscount.price || parseFloat(salePriceValue) < parseFloat(saleData.memberDiscount.price)) {
          // delete properties.__member_discount_percentage;
          properties = { ...properties, ...dynamicSaleProperty };
        } else {
          console.log('Member discount should apply.');
        }
      } else if (saleData.applicableSale == LifSale.FWP_SALE) {
        const { hasFreeProduct, hasSecondProduct, saleDetails } = Alpine.store('fwpOffer');
        const thisCollection = window.location.origin + window.location.pathname;
        if (hasFreeProduct && !hasSecondProduct && saleDetails.targetCollection == thisCollection) {
          properties._fwp_second_product = true;
        }
      
      } else if (saleData.applicableSale == LifSale.INCREMENTAL_SALE) {

        const { saleName, salePriceValue, offerCode } = saleData.incrementalSale;
        const variantPrice = this.product.variants[0].price / 100;
        if (variantPrice > this.incrementalSale.salePriceValue) {

          const lineItemIndex = offerCode == 'v2' ? Alpine.store('incrementalSaleV2').activeIndex : Alpine.store('incrementalSale').bundleItems.length;

          if (Alpine.store('incrementalSaleV2').isCartInProgress) {
            console.log('Cart is still in progress...');
            return false;
          }
          Alpine.store('incrementalSaleV2').isCartInProgress = true;

          // Avoid duplicate offer to add
          if (Alpine.store('cart').isCartInProgress) {
            console.log('Sorry, Cart is still adding offer to cart. So please wait to finish!');
            return;
          }

          // Avoid duplicate offer to add
          if (Alpine.store('incrementalSale').bundleItemsByIndex[lineItemIndex]) {
            console.log('This offer item is already in your cart!');
            return;
          }

          properties.__incremental_sale = {
            type: Alpine.store('incrementalSale').isCompleted || offerCode == 'v2' ? 'FIXED' : 'SALE',
            price: salePriceValue * 100,
            offerCode: offerCode,
            lineItemIndex,
            saleName
          }

          Alpine.store('cart').isCartInProgress = true;
        }
      }
      
      // blackFridaySale should be combined with dynamic sale
      if (Alpine.store('blackFridaySale').isActive) {
        if (saleData.applicableSale == LifSale.BLACK_FRIDAY) {

          // Avoid duplicate offer to add
          if (Alpine.store('cart').isCartInProgress) {
            console.log('Sorry, Cart is still adding offer to cart. So please wait to finish!');
            return;
          }

          // Avoid duplicate offer to add
          if (Alpine.store('blackFridaySale').offerItemsByIndex[saleData.blackFriday.offerIndex]) {
            console.log('This offer item is already in your cart!');
            return;
          }

          properties.__black_friday_sale = { isOfferProduct: true, index: saleData.blackFriday.offerIndex };

          // Using '__winter_bundle_sale_fixed_price' to make this work as fixed price in Checkout Extensiblity App without modifying code
          properties.__winter_bundle_sale_fixed_price = { 
              type: 'FIXED', 
              price: parseFloat(saleData.blackFriday.salePriceValue) * 100,
              saleName: saleData.blackFriday.saleName
          }

          Alpine.store('cart').isCartInProgress = true;
        } else {
          if (Alpine.store('blackFridaySale').isAllowedBundleProduct(this.product)) {
            properties.__black_friday_sale = { isBundleProduct: true }
          }
        }
      }

      if (this.selectedVariant.price == 0) {
        properties._is_absolute_free_product = true;
        properties._free_theshold = window.__LIF__.free_product_threshold;
      }

      if (this.isProductDODLimt1) {
        properties = { ...properties, __has_dod_limit_1 : true };
        const { removeItem, dodLimit1Product } = Alpine.store('cart');

        // Check if dod limit 1 product already exist
        if (dodLimit1Product) {
          await removeItem(dodLimit1Product.key, false);
        }
      }

      if (this.product.is_oversold_product) {
        properties.__is_oversold_product = true;
      }

      // Check if collection offer is active and redirect is enabled
      const { saleDetails, offerCurrentSettings: offerSettings } = Alpine.store('offer1Free');

      if (offerSettings) {
        properties._is_funnel_product = true;

        if(offerSettings.enable_url_redirect) {
          atcRedirect = offerSettings.url_redirect+'?offersettings='+saleDetails.offerSettingKey;
        }
      }

      // Check if collection offer is active and redirect is enabled
      const { isActive, cartFunnelProduct } = Alpine.store('freeProductTemplate');

      if (isActive && hasAbsoluteFreeProduct && !properties._is_absolute_free_product && !cartFunnelProduct) {
        properties._is_funnel_product = true;
      }

      const item = {
        id: this.selectedVariant.id,
        quantity: 1,
        properties
      }

      if (this.product.selling_plan_id) {
        item.selling_plan = this.product.selling_plan_id;
      }

      // Close shop simillar and Complete a look modal.
      if (this.showModal) {
        this.showModal = false;
      }

      if (atcRedirect) {

        if (atcRedirect[0] == '#') {
          
          Alpine.store('freeProductTemplate').atcInitiated = true;

          setTimeout(() => {
            const element = document.querySelector(atcRedirect);
            console.log(element);

            if (element) {
              const headerOffset = 80;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.scrollY - headerOffset;

              window.scrollTo({ top: offsetPosition, behavior: "smooth" });
            } else {
              console.log('No element to scroll.');
            }
          }, 500); // Let's Load visibility
        }

        Alpine.store('cart').addItems(bundleItem ? [item, bundleItem] : [item], () => {
          Alpine.store('cart').isCartInProgress = false;
          if (atcRedirect[0] != '#') {
            window.location.href = atcRedirect
          }
        }, false);
      } else {
        Alpine.store('cart').addItems(bundleItem ? [item, bundleItem] : [item], () => {
          Alpine.store('cart').isCartInProgress = false;

          if (saleData.applicableSale == LifSale.INCREMENTAL_SALE) {
            console.log('isCartInProgress false');
            Alpine.store('incrementalSaleV2').isCartInProgress = false;
          }
        });
      }
    },

    isOOS(thisOptionPosition, thisOptionValue) {
      // console.log(`${thisOptionPosition} -> ${thisOptionValue}`);
      // return selectedColor;
      // if (availbleSwatches.length === 0) {
      //   return true;
      // }
      // return !availbleSwatches.split(',').includes(selectedColor);

      const thisVariant = this.product.variants.find((v) => {
        let matched = true;
        for (let optionPosition in this.selectedOptions) {
          if (optionPosition == thisOptionPosition) {
            if (v['option'+thisOptionPosition] != thisOptionValue) {
              matched = false;
            }
          } else {
            if (this.selectedOptions.hasOwnProperty(optionPosition)) {
              if (v['option'+optionPosition] != this.selectedOptions[optionPosition]) {
                matched = false;
              }
            }
          }
        }

        return matched;
      });

      if (!thisVariant) {
        return false;
      }

      return thisVariant.remaining_quantity <= 0 && thisVariant.inventory_policy != 'continue';
    },
    selectOptionAndATC(optionPosition, optionValue, saleData) {
      this.selectedOptions[optionPosition] = optionValue;
      this.showOptionSelection = false;
      this.addToCart(saleData);
    },

    selectOption(optionPosition, optionValue) {
      this.selectedOptions[optionPosition] = optionValue;
      // this.selectedSize = optionValue;

      // Check if selected variant is OOS
      if (this.optionIndex.hasOwnProperty('size') && this.optionIndex.hasOwnProperty('color') 
        && (this.isSelectedVariantOOS || this.selectedOptions[this.optionIndex.size + 1] === null)) {
        
        console.log('Selected option is OOS: ');
        // Auto select available size

        const sizePosition = this.optionIndex.size + 1;
        const colorPosition = this.optionIndex.color + 1;

        console.log('Checking for first available size for selected color.');
        const firstAvailableVariant = this.product.variants.find((v) => {
          return v['option'+colorPosition] == this.selectedOptions[colorPosition] && (v.remaining_quantity > 0 || v.inventory_policy == 'continue');
        });

        if (firstAvailableVariant) {
          console.log('Found first available size.');
          // Set first available variant size
          this.selectedOptions[sizePosition] = firstAvailableVariant['option'+sizePosition];
        } else {
          console.log('No size is available.');
          this.selectedOptions[sizePosition] = null;
        }
      }
    },
    // memberDiscountPercentage() {
    //   const memberPriceTagPrefix = 'MEMBER-';
    //   const productTags = this.product.tags.split(',').map((t) => t.trim());

    //   const memberTag = productTags.find((item) => item.indexOf(memberPriceTagPrefix) > -1);
    //   const memberDiscountPerc = typeof memberTag !== 'undefined' ? memberTag.replace(memberPriceTagPrefix, '') : 0;

    //   return parseFloat(memberDiscountPerc);
    // },
  }));

  Alpine.data('cartItemEdit', (productHandle, productImageURL, cardIndex) => ({
    customerLoggedIn: document.getElementById('customerLoggedIn') && document.getElementById('customerLoggedIn').value === 'true', 
    showUpdateItemPopup: false, 
    showDeleteItemPopup: false,
    showWishlistItemPopup: false,
    isRemoveFromWishlist: false,
    editItemKey: null,
    editItemQty: 1,
    removeItemKey: null,

    editItem(productHandle, editItemKey, editItemQty) {
      // debugger;
      if (Alpine.store('cart').isCartQtyInProgress) {
        console.log('Cart update is already in Progress.');
        return false;
      }

      Alpine.store('cart').showUpdateItemPopup = true;
      Alpine.store('cart').isSideCartOpen = false;

      // console.log('productHandle: ');
      // console.log(productHandle);

      this.editItemKey = editItemKey;
      this.editItemQty = editItemQty;

      const cartItem = Alpine.store('cart').cartItems.find(c => c.key == editItemKey);
      
      Alpine.store('cart').editItemDetails = {
        key: editItemKey,
        qty: editItemQty,
        price: {
          compare_at_price: cartItem.compare_at_price / 100,
          final_price: cartItem.final_price / 100,
          original_price: cartItem.original_price / 100,
        }
      };
      const selectedVariantId = editItemKey.split(':')[0];

      document.getElementById('edit_product_info').innerHTML = '';
      // document.querySelectorAll('.edit_product_info').forEach(element => {
      //   element.innerHTML = '';
      // });
      console.log(`/products/${productHandle}?view=cart-edit&variant=` + selectedVariantId);
      fetch(`/products/${productHandle}?view=cart-edit&variant=` + selectedVariantId)
      .then((response) => response.text())
      .then((html) => {
        // console.log(html);
        console.log(document.getElementById('edit_product_info'));
        document.getElementById('edit_product_info').innerHTML = html;
        // document.querySelectorAll('.edit_product_info').forEach(element => {
        //   element.innerHTML = html;
        // });
      })
      .catch((e) => {
        console.error(e);
        // console.log('Error fetching product info and populating it.');
      });
    },

    updateItem(e) {
      e.preventDefault();

      Alpine.store('pdp').disabledEditATC = true;

      const { key: editItemKey, qty: editItemQty } = Alpine.store('cart').editItemDetails;

      const variatSelector = document.querySelector('variant-selects');

      if (variatSelector.currentVariant) {
        // console.log('Log current variant id: ');
        // console.log(variatSelector.currentVariant.id)
        // debugger;
        const selectedItem = Alpine.store('cart').cartItems.find((i) => i.key == editItemKey);
        console.log('editItemKey: ', editItemKey);
        const item = {
          id: variatSelector.currentVariant.id,
          quantity: editItemQty,
          properties: selectedItem.properties.attributes,
        }

        if (selectedItem.selling_plan && selectedItem.selling_plan.id) {
          item.selling_plan = selectedItem.selling_plan.id
        }

        // Remove existing item
        Alpine.store('cart').removeAndAddItem(editItemKey, item, () => {;
          Alpine.store('cart').showUpdateItemPopup = false;
          Alpine.store('cart').isSideCartOpen = true;
          Alpine.store('pdp').disabledEditATC = false;
        })
      }
    }
  }));

  Alpine.data('PDPVariantSelection', (selected) => ({
    selected: selected,

    handleVariantChange(event) {
      console.log('handleVariantChange...');
      if (event.target.checked) {
        this.selected = event.target.value;
      } else {
        this.selected = '';
      }
    },
    get selectedSizeFullName() {

      const sizeFullNames = {
        S: 'Small',
        M: 'Medium',
        L: 'Large',
        XL: 'Extra Large',
        '2X': 'Extra Large 2',
        '3X': 'Extra Large 3',
        '4X': 'Extra Large 4',
      }; 

      return sizeFullNames.hasOwnProperty(this.selected) ? sizeFullNames[this.selected] : this.selected;
    }
  }));

  Alpine.data('productForm', (selectedId) => ({
    selectedVariantId: selectedId,
    selectedQuantity: 1,
    
    handleVariantChange(event) {
      console.log('productForm: handleVariantChange...');
      console.log(event.target.value);

      this.selectedVariantId = event.target.value;
    }
  }));

  Alpine.data('countdownTimer', (promoLength, slideSpeed) => ({ 
    startTime: null,
    remaintingTime: 0,
    saleName: '', 
    targetCollection: '' ,
    salesBanners: [],
    activeSlide: 0,
    isActiveSaleTimer: false,
    timerInterval: null,
    slideInterval: null,

    get offerActivationCompleted() {
      return Alpine.store('customBundle').activationCompleted || 
      Alpine.store('dynamicSale').activationCompleted || 
      Alpine.store('offer1Free').activationCompleted ||
      Alpine.store('incrementalSale').activationCompleted;
    },

    init() {
      this.initTimer();

      this.$watch('offerActivationCompleted', () => {
        this.initTimer();
      });
    },

    initTimer() {
      let { saleDetails } = Alpine.store('dynamicSale');

      if (!saleDetails) {
        saleDetails = Alpine.store('customBundle').thisSaleDetails;
      }

      if (!saleDetails) {
        saleDetails = Alpine.store('customBundle').recentSaleDetails;
      }

      if (!saleDetails) {
        saleDetails = Alpine.store('incrementalSale').saleDetails;
      }

      if (saleDetails && saleDetails.saleExpiry) {

        if (this.timerInterval) {
          clearInterval(this.timerInterval);
        }

        this.isActiveSaleTimer = true;
        this.saleName = saleDetails.saleName;
        this.startTime = saleDetails.saleExpiry.timerExpiryTime;
        this.targetCollection = saleDetails.targetCollection;
        
        if (this.startTime) {
          window.countDownSettings = {
            timerStartTime: this.startTime,
          };

          this.remaintingTime = this.calculateRemainingTime();

          this.timerInterval = setInterval(() => {
            const remaintingTime = this.calculateRemainingTime();

            if (remaintingTime) {
              this.remaintingTime = remaintingTime;
            } else {
              this.startTime = null;
              this.isActiveSaleTimer = false;
              clearInterval(this.timerInterval);
            }
          }, 1000);
        }
      } else {
        // To skip index for sale timer
        this.activeSlide = 1;
        this.isActiveSaleTimer = false;
        
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
        }
      }

      // Set timer to slide show
      let numberOfSlides = parseInt(promoLength);
      if (this.isActiveSaleTimer) {
        numberOfSlides += 1;
      }

      if (this.slideInterval) {
        clearInterval(this.slideInterval);
      }

      this.slideInterval = setInterval(() => {
        this.activeSlide = (this.activeSlide + 1) % numberOfSlides;

        if (!this.isActiveSaleTimer && this.activeSlide === 0) {
          // To skip index for sale timer
          this.activeSlide = 1;
        }

      }, slideSpeed);
    },

    get saleNameDisplay() {
      if (!this.saleName) {
        return '';
      }
      return this.saleName.replaceAll('_', ' ').toUpperCase();
    },
    get bannerText() {
      if (!this.salesBanners) {
        return null;
      }
      // Find banner text
      const banner = this.salesBanners.find((b) => b.sales_tag_name === this.saleName);
      return banner ? banner.sales_banner_text.replace('{{sale_countdown}}', this.remaintingTime) : null;
    },
    calculateRemainingTime() {
      if (!this.startTime) {
        // this.$emit('onExpired');
        return false;
      }

      const remainingSeconds = this.startTime - new Date().getTime();

      if (remainingSeconds < 0) {
        // this.$emit('onExpired');
        return false;
      }

      return this.secondsToHms(remainingSeconds / 1000);
    },
    secondsToHms(sec) {
      const seconds = Number(sec);

      let day = '';

      const d = Math.floor(seconds / (3600 * 24));
      if (d >= 1) {
        day = `${d}d:`;
      }

      const h = this.addLeadingZero(Math.floor((seconds / 3600) % 24).toString());
      const m = this.addLeadingZero(Math.floor((seconds % 3600) / 60).toString());
      const s = this.addLeadingZero(Math.floor((seconds % 3600) % 60).toString());

      return `${day} ${h}h : ${m}m : ${s}s`;
    },
    addLeadingZero(num) {
      return num.padStart(2, '0');
    },

  }));

  // Reactive reference of store for easy access
  Alpine.data('cartDrawer', () => ({
    init() {
      this.$watch('isCartLoading', (isLoading) => {
        if (!isLoading) {
          Alpine.store('blackFridaySale').adjustBundleTag('blackfriday-bundle-item-side-cart');
        }
      });

      // this.$watch('buyMoreBundleItems', (items) => {
      //   Alpine.store('buyMoreGetFreeOffer').checkAndUpdateFreeItems(items);
      // });
    },
    get hasSpendBasedFreeItems() {
      return !!Alpine.store('cart').cartItems.find((i) => i.properties.attributes.__spend_based_offer);
    },
    get isCartLoading() {
      return Alpine.store('cart').isLoading;
    },
    get cartHasLoaded() {
      return Alpine.store('cart').cartHasLoaded
    },
    get hasFreeTemplateBundle() {
      return Alpine.store('freeProductTemplate').isActive && Alpine.store('freeProductTemplate').cartAbsoluteFreeProduct;
    },
    get recentlyAddedItem() {
      return Alpine.store('cart').recentlyAddedItem
    },
    get recentlyAddedItemHasLimitOne() {
      if (!this.recentlyAddedItem) {
        return null;
      }
      return this.recentlyAddedItem.properties.attributes.__has_dod_limit_1
    },
    get cartItemHasLimitOne() {
      return Alpine.store('cart').dodLimit1Product;
    },
    get recentlyAddedItemIsBundleItem() {
      if (!Alpine.store('cart').recentlyAddedItem) {
        return null;
      }

      const itemAttributes = Alpine.store('cart').recentlyAddedItem.properties.attributes;

      return !!(itemAttributes.__winter_bundle_sale
      || itemAttributes.__is_winter_product
      || itemAttributes._bb_upgrade_kit
      || itemAttributes._bb_upgrade_shirt
      || (itemAttributes._is_free_shirt && itemAttributes._applied_offer_type == 'fwp')
      || itemAttributes._fwp_second_product)
      || Alpine.store('incrementalSale').isBundleItem(Alpine.store('cart').recentlyAddedItem)
      || (this.hasFreeTemplateBundle && (itemAttributes._is_absolute_free_product || itemAttributes._is_funnel_product));
    },
    get cartBundleProduct() {
      return Alpine.store('customBundle').bundleKeyProducts;
    },
    get fwpItems() {
      const fwpFreeShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes._is_free_shirt && i.properties.attributes._applied_offer_type == 'fwp');
      const fwpSecondShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes._fwp_second_product);

      if (fwpFreeShirt || fwpSecondShirt) {
        return [fwpFreeShirt, fwpSecondShirt];
      } else {
        return [];
      }
    },
    get buyMoreBundleItems() {
      return Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__buy_more_get_free);
    },
    get cartHasIncrementalItem() {
      return !!Alpine.store('cart').cartItems.find((i) => i.properties.attributes.__incremental_sale);
    },
    get cartBBKitItems() {
      const bbKit = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_kit);
      const bbShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_shirt);

      if (bbKit || bbShirt) {
        return [bbKit, bbShirt];
      } else {
        return [];
      }
    },
    get cartBBKitItemsTitle() {
      const bbKit = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_kit);
      const bbShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_shirt);

      if (!bbKit || !bbShirt) {
        return 'noksdfnlsdf'
      }

      let kitPrice = bbKit.final_line_price / 100;
      if (bbKit.properties.attributes['_bb_offer_type--free_kit']) {
        kitPrice = bbShirt.final_line_price / 100;
      }

      return `${bbKit.product_title} - $${kitPrice}`;
    },
    get cartBundleItems() {
      const { hasBundleItem, cartBundleItems } = Alpine.store('cart');
      if (cartBundleItems.length > 0 && hasBundleItem) {
        return cartBundleItems;
      }

      return [];
    },
    get hasBundleItem() {
      return Alpine.store('cart').hasBundleItem;
    },
    get allIncludedBundleComponents() {
      return Alpine.store('customBundle').allIncludedBundleComponents;
    },
    get allItemsByBundleIndex() {
      return Alpine.store('customBundle').allItemsByBundleIndex;
    },
    get nonBundleCartItems() {
      return Alpine.store('cart').cartItems.filter((i) => {
        const isBundleItem = (
          i.properties.attributes.__winter_bundle_sale 
          || i.properties.attributes.__is_winter_product
          || i.properties.attributes._bb_upgrade_kit
          || i.properties.attributes._bb_upgrade_shirt
          || (i.properties.attributes._is_free_shirt && i.properties.attributes._applied_offer_type == 'fwp')
          || i.properties.attributes._fwp_second_product
          || Alpine.store('incrementalSale').isBundleItem(i))
          || (this.hasFreeTemplateBundle && (i.properties.attributes._is_absolute_free_product || i.properties.attributes._is_funnel_product));
        const isRecentItem = this.recentlyAddedItem && i.key == this.recentlyAddedItem.key;
        return !isBundleItem && !isRecentItem;
      });
    },
    get blackFridaySaleSettings() {
      return Alpine.store('blackFridaySale').offerSettings;
    },
    isBlackFridayOfferProduct(item) {
      if (!item) {
        return false;
      }
      const properties = item.properties.attributes;
      return properties.__black_friday_sale && properties.__black_friday_sale.isOfferProduct;
    },
    isAddQtyNotAllowed(item) {
      if (!item) {
        return false;
      }

      const properties = item.properties.attributes;
      return (properties.__buy_more_get_free && item.line_price == 0) 
      || properties.__spend_based_offer 
      || properties._bb_upgrade_kit 
      || properties._bb_upgrade_shirt;
    }
  }));

  // custom directives
  Alpine.directive('uppercase', el => {
    el.textContent = el.textContent.toUpperCase()
  });

  Alpine.data('global', () => ({
    init() {
      this.$watch('isSideCartOpen', (isOpen) => {
        setTimeout(() => {
          
          if (!Alpine.store('cart').showUpdateItemPopup) {
            Alpine.store('screen').isScrollableBody = !isOpen;
          }

          const stickyButton = document.getElementById('sticky-add-to-cart');
          if (stickyButton) {
            stickyButton.style.display = isOpen ? 'none': '';
          }
        }, 1000); // Let's wait to close quick add popup
      });

      this.$watch('isIncremementalSaleCompleted', (newValue, previousValue) => {
        // console.log('isIncremementalSaleCompleted: '+this.isIncremementalSaleCompleted);
        if (!previousValue && newValue) {
          Alpine.store('incrementalSale').showSuccessPopup = true;
        }
      });
    },
    get isSideCartOpen() {
      return Alpine.store('cart').isSideCartOpen;
    },
    get isIncremementalSaleCompleted() {
      return Alpine.store('incrementalSale').isCompleted;
    },
    cleanKitProductTitle(title) {
      // Regex pattern to match " - " followed by a number (integer or decimal)
      const pattern = / - \d+(\.\d+)?$/;
      // Using replace to remove the matched pattern     
      const cleanedTitle = title.replace(pattern, "");
      return cleanedTitle;
    },
  }));

  Alpine.data('productRecommendations', () => ({
    maxProductDisplay: 4,

    init() {
      this.$watch('recentlyAddedItem', () => {
        // console.log('productRecommendations: recentlyAddedItem changed.');

        const rec = document.querySelector('product-recommendations');
        if (rec) {
          // console.log('Reloading loadRecommendations...');
          rec.loadRecommendations();
        }
      });
    },

    get recentlyAddedItem() {
      return Alpine.store('cart').recentlyAddedItem
    },
  }));

  Alpine.data('fwpsetPopup', () => ({
    settings: null,
    fwpProduct: null,
    timer: {
      hours: 0,
      minutes: 0,
      seconds: 0,
    },

    init() {
      try {        

        if (Alpine.store('fwpOffer').saleDetails && Alpine.store('fwpOffer').settings) {
          this.settings = Alpine.store('fwpOffer').settings;

          this.startTimer();
          this.loadProduct();
        }

      } catch(error) {
        console.error(error);
      };
    },

    async loadProduct() {

      console.log('-----------------------------------------------------------------------loadProduct: .....');
      console.log(Alpine.store('fwpOffer').productHandle);

      const productHandle = Alpine.store('fwpOffer').productHandle;
      if (productHandle) {
        const resp = await fetch(`https://www.loveinfaith.life/products/${productHandle}?view=json`);
        const response = await resp.json();

        if (response.handle) {
          this.fwpProduct = response;  
        }
      }
    },

    startTimer() {
      this.updateTime();
      setInterval(() => {
        this.updateTime();
      }, 1000);
    },

    updateTime() {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0); // Set midnight as 24:00

      const diff = midnight - now; // Difference in milliseconds
      if (diff > 0) {
        this.timer.hours = Math.floor(diff / 1000 / 60 / 60); // Convert ms to hours
        this.timer.minutes = Math.floor((diff / 1000 / 60) % 60); // Convert ms to minutes
        this.timer.seconds = Math.floor((diff / 1000) % 60); // Convert ms to seconds
      } else {
        this.timer.hours = 0;
        this.timer.minutes = 0;
        this.timer.seconds = 0;
      }
    },
    get hasMultipleColor() {
      if (!this.fwpProduct) {
        return null;
      }
      return !!this.fwpProduct.options.find((o) => o.name.toLowerCase() == 'color' && o.values.length > 1)
    },
    getColorCode(colorName) {
      const colorHandle = colorName.toLowerCase().replace(/\s+/g, '-');
      return this.product.color_values[colorHandle] ? this.product.color_values[colorHandle] : null;
    },

    get ctaColors() {
      if (!this.fwpProduct) {
        return [];
      }
      const ctaColors = this.settings.all.popup_cta_colors;
      return [ctaColors[0].toUpperCase(), ctaColors[1].toUpperCase()];
    },

    get timerBGColor() {
      if (!this.fwpProduct) {
        return null;
      }
      return this.settings.all.countdown_timer_background_color.toUpperCase();
    },
  }));
  
  Alpine.data('pdpCROMessages', () => ({
    previousIndex: null,
    currentIndex: 0,
    messageCount: 0,

    init() {
      window.addEventListener('DOMContentLoaded', () => {
        this.messageCount = document.querySelectorAll('.pdp-cro-message').length;

        setInterval(() => {
          this.previousIndex = this.currentIndex;
          this.currentIndex += 1;

          if (this.currentIndex == this.messageCount) {
            this.currentIndex = 0;
          }
        }, 4000);
      });
    },
  }));

  Alpine.data('userSignup', () => ({
    async login(e) {
      e.preventDefault();

      const loginForm = document.getElementById('customer_login');
      console.log(loginForm);

      this.$refs.errorContainer.innerHTML = '';

      try {
        const res = await fetch(loginForm.getAttribute('action'), {
          method:'post', 
          body: new FormData(loginForm)
        });

        const html = await res.text();
        if (html.includes('Incorrect email or password.')) {
          this.$refs.errorContainer.innerHTML = 'Incorrect email or password.';
        } else {            
          const loginUrl = document.querySelector('[data-login-url]').getAttribute('data-login-url');
          window.location.href = loginUrl;
        }

      } catch (error) {
        console.error(error);
      }

    }
  }));

  Alpine.data('createAccountPopup', () => ({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    errors: {},
    validateForm() {
        this.errors = {};
  
        if (!this.firstName) {
            this.errors.firstName = 'First name is required.';
        }
  
        if (!this.lastName) {
            this.errors.lastName = 'Last name is required.';
        }
  
        if (!this.phoneNumber || this.phoneNumber.length !== 10 || !/^\d{10}$/.test(this.phoneNumber)) {
            this.errors.phoneNumber = 'Phone number must be 10 digits.';
        }
  
        if (!this.password || this.password.length < 8) {
            this.errors.password = 'Password must be at least 8 characters long.';
        }
  
        return Object.keys(this.errors).length === 0;
    },
    submitForm() {
        if (this.validateForm()) {
            // Submit the form if valid
            document.getElementById('create_customer').submit();
        }
    }
  }));
  
  Alpine.data('resetPasswordPopup', () => ({
    newPassword: '',
    confirmNewPassword: '',
    errors: {},
    validateForm() {
        this.errors = {};
  
        if (!this.newPassword || this.newPassword.length < 8) {
            this.errors.newPassword = 'Password must be at least 8 characters long.';
        }

        if (this.newPassword != this.confirmNewPassword) {
            this.errors.confirmNewPassword = 'The password you entered does not match';
        }
  
        return Object.keys(this.errors).length === 0;
    },
    submitForm() {
        if (this.validateForm()) {
            // Submit the form if valid
            document.getElementById('reset_customer_password_modal_form').submit();
             console.log('Reset Password Form Submitted');
        }
    }
  }));
  
  Alpine.data('forgotPasswordPopup', () => ({
    enteredEmail: '', 
    accountExists: false, 
    errorMessage: '', 
    successMessage: '', 
    showEmailErrorMessage: false, 
    showSuccessMessage: false,
    async validateEmail() {
        const email = this.enteredEmail;
        const apiUrl = `${VERIFY_CUSTOMER_EMAIL_API_URL}?email=${email}&timestamp=${Date.now()}`;
        
        try {
            const response = await fetch(apiUrl);
            const data = await response.json();

            if (data && data.exists === true) {
                console.log('Account exists:', data.name);
                this.accountExists = true;
                this.successMessage = 'Email Sent. Check your email to reset your password.';
                this.showSuccessMessage = true;
                this.showEmailErrorMessage = false;
                return true;
            } else {
                console.log('Account does not exist');
                this.accountExists = false;
                this.errorMessage = 'Account does not exist with the provided email.';
                this.showEmailErrorMessage = true;
                this.showSuccessMessage = false;
                return false;
            }
        } catch (error) {
            console.error('Error checking account:', error);
            this.errorMessage = 'Error checking account. Please try again later.';
            this.showEmailErrorMessage = true;
            this.showSuccessMessage = false;
            return false;
        }
    },
    async submitResetPasswordForm() {
      event.preventDefault();
      const isValid = await this.validateEmail();
      if (isValid) {
          // Submit the form if valid
          // Instead of redirecting, you can handle the submission here
          const form = document.getElementById('recover_customer_password');
          const formData = new FormData(form);
          formData.append('email', this.enteredEmail);
          
          try {
          const response = await fetch(form.action, {
              method: 'POST',
              body: formData,
          });

          if (response.ok) {
              formData.forEach((value, key) => {
                  console.log(`${key}: ${value}`);
              });
              console.log('Password reset request submitted.');
              this.showResetPasswordSuccessfulModal = true;
              this.showForgotPasswordModal = false;
          } else {
              console.error('Failed to submit password reset request.');
          }
          } catch (error) {
          console.error('Error submitting form:', error);
          }
      }
    }
  }));

  Alpine.data('navbarHeaderMenu', () => ({
    showLoginModal: false, 
    showWelcomeModal: false,
    showEnterPasswordModal: false, 
    showCreateAccountModal: false, 
    showForgotPasswordModal: false,
    showResetPasswordSuccessfulModal: false, 
    showResetPasswordModal: false,
    showEmailErrorMessage: false, 
    enteredEmail: '', 
    errorMessage: '',
    accountExists: false,
    customerName: '',
    captureEmail() { 
        this.enteredEmail = this.$refs.emailInput.value; 
        console.log(this.enteredEmail); // For debugging
    },
    validateEmail() {
        console.log('validateEmail');
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailPattern.test(this.enteredEmail)) {
            console.log('wrongEmail');
            this.errorMessage = 'Please enter a valid email address.';
            this.showEmailErrorMessage = true;
            return false;
        }
        this.errorMessage = '';
        this.showEmailErrorMessage = false;
        this.checkIfAccountExists(); // Check if the account exists
        return true;
    },
    checkForWelcome() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('welcome') === 'true') {
        this.showWelcomeModal = true;
      }
    },
    checkIfAccountExists() {
        const email = this.enteredEmail;
        const apiUrl = `${VERIFY_CUSTOMER_EMAIL_API_URL}?email=${email}&timestamp=${Date.now()}`;
        
        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                if (data && data.exists === true) {
                    console.log('Account exists:', data.name);
                    this.accountExists = true;
                    this.customerName = data.name;
                    this.showEnterPasswordModal = true;  // Show password modal if account exists
                } else {
                    console.log('Account does not exist');
                    this.accountExists = false;
                    this.showCreateAccountModal = true;  // Show create account modal if no account exists
                }
                this.showLoginModal = false;
            })
            .catch(error => {
                console.error('Error checking account:', error);
                this.errorMessage = 'Error checking account. Please try again later.';
                this.showEmailErrorMessage = true;
            });
    }
  }));

  Alpine.data('accountInfo', (addressCount) => ({
    editMyInfo: false, 
    addressCount: addressCount, 
    currentAddressPage: 1, 
    addressPageSize: 2, 
    editAddressInfo: false, 
    addAddressInfo: false, 
    selectedAddress: {},
    myInfoUpdteError: null,

    init() {
      this.$watch('myInfoUpdteError', () => {
        setTimeout(() => {
          this.myInfoUpdteError = null;
        }, 10000);
      });
    },

    updateMyInfo(e) { 
      e.preventDefault();

      const formData = new FormData(e.target);

      const backendURL = STORE_BACKEND_URL || 'https://cron.loveinfaith.work/store-backend-staging';
      fetch(`${backendURL}/customer/updateAccountInfo`, {
        method: 'POST',
        body: formData,
      })
      .then((r) => r.json())
      .then((res) => {

        if (res.status == 'success') {
          this.editMyInfo = false;
          window.location.reload();
        } else {
          this.myInfoUpdteError = res.text;
        }
      });
    }
  }));

  Alpine.data('freeProductTemplate', () => ({
    showSuccessPopup: false,
    init() {
      this.$watch('isUnlocked', (newValue, oldValue) => {
        if (newValue != oldValue && this.isUnlocked) {
          this.showSuccessPopup = true;
        }
      });
    },

    get isUnlocked() {
      return !!Alpine.store('freeProductTemplate').cartAbsoluteFreeProduct 
        && !!Alpine.store('freeProductTemplate').cartFunnelProduct;
    }
  }));
  Alpine.data('blackFridaySale', () => ({
    init() {

      // Auto scroll for mobile view
      if (Alpine.store('screen').isMobile && Alpine.store('blackFridaySale').offerSwitched) {
        setTimeout(() => {
          // document.getElementById('black_friday_offer_tile_2').scrollToView();

          // /* Note: This method is not smooth using scroll-smooth class instead*/
          // const step = 1;
          // let leftPosition = 0;
          // let isReverse = false;
          // let interval = setInterval(() => {
          //   leftPosition = isReverse ? leftPosition - step : leftPosition + step;
          //   // this.$refs.offerTileContainer.scrollLeft = leftPosition;
          //   this.$refs.offerTileContainer.scroll(leftPosition, 0);

          //   if (leftPosition == 200) {
          //     isReverse = true;
          //   }

          //   if (leftPosition == 0) {
          //     // isReverse = false;
          //     clearInterval(interval);
          //   }
          // }, step);

          this.$refs.offerTileContainer.scrollLeft = 300;

          setTimeout(() => {
            this.$refs.offerTileContainer.scrollLeft = 0;
          }, 1000);

        }, 1000);
      }

      const { offers, offerItemsByIndex, saleDetails } = Alpine.store('blackFridaySale');

      // Check if offer collection is loaded even after offer claimed
      for(const [index, offer] of offers.entries()) {
        const offerCollection = '/collections/'+offer.offer_collection;
        if(offerItemsByIndex[index] && window.location.pathname == offerCollection) {
          // Redirect to base collection URL
          window.location.href = saleDetails.targetCollection;
        }
      }

      // console.log('this.activeOffer: ');
      // console.log(this.activeOffer);

      if (this.activeOffer) {
        this.handleActiveOfferChange();
      }

      this.$watch('activeOffer', (newActiveOffer, oldActiveOffer) => {
        console.log('newActiveOffer changed');
        if (!oldActiveOffer && newActiveOffer) {
          setTimeout(() => {
            this.handleActiveOfferChange();
          }, 3000); // let's activate offer amd cart
        }
      });

      this.$watch('bundleItems', (currentBundleItems, previousBundleItems) => {

        const { offers, offerItemsByIndex } = Alpine.store('blackFridaySale');

        // Check if bundle item is added
        if (currentBundleItems.length > previousBundleItems.length) {
          // Track if bundle item threshold met
          for(const offer of offers) {
            const offerCollection = '/collections/'+offer.offer_collection;
            if (this.bundleItems.length == offer.threshold && window.location.pathname != offerCollection) { // Check of page is already on same collection
              // Redirect to offer collection URL
              window.location.href = offerCollection;
            }
          }

        } else if (currentBundleItems.length < previousBundleItems.length) { // Check if bundle item is deleted

          console.log('Bundle item is deleted.');

          // Check if offer threshold expired
          for(const offer of offers) {
            if (currentBundleItems.length < offer.threshold && offerItemsByIndex[offer.index]) { 
              console.log('Going to delete offer item too:');

              // remove offer item too
              const offerItem = offerItemsByIndex[offer.index];
              console.log(offerItem);
              Alpine.store('cart').removeItem(offerItem.key);
            }
          }
        }
      });

      this.$watch('offerItems', (currentOfferItems, previousOfferItems) => {
        // Detect if new offer item added
        if (previousOfferItems.length < currentOfferItems.length) {
          console.log('New offer item added...');

          const { baseURL } = Alpine.store('URL');
          const { targetCollection } = Alpine.store('blackFridaySale').saleDetails;

          let redirectUrl = targetCollection;

          // Check if offer target collection is other than current collection
          if (baseURL != redirectUrl) {

            // Check if offer is completed
            if (currentOfferItems.length == Alpine.store('blackFridaySale').offers.length ) {
              window.sessionStorage.setItem('LIF-PARAM--AUTO_OPEN_SIDE_CARD', '1');
            }
            // Redirect to main collection
            window.location.href = redirectUrl;
          }
        } else if (previousOfferItems.length > currentOfferItems.length) {
          // Offer is deleted redirect to offer collection again for missing offer
          const offerItemsByIndex = Alpine.store('blackFridaySale').offerItemsByIndex;
          for (let i = 0; i < offerItemsByIndex.length; i++)  {
            // Find missing offer
            if (!offerItemsByIndex[i]) {
              // Activate missing offer 
              const activeOffer = Alpine.store('blackFridaySale').offfers[i];

              const offerCollection = '/collections/'+activeOffer.offer_collection;
              if(window.location.pathname != offerCollection) {
                // Redirect to base collection URL
                window.location.href = offerCollection;
              }
            }
          }
        }
      });

      // check if open sideCard is set
      const isOpenSideCart = window.sessionStorage.getItem('LIF-PARAM--AUTO_OPEN_SIDE_CARD');
      if (isOpenSideCart) {
        Alpine.store('cart').isSideCartOpen = true;
        window.sessionStorage.removeItem('LIF-PARAM--AUTO_OPEN_SIDE_CARD');
      }
    },

    handleActiveOfferChange() {
      // debugger;
      console.log('active offer is fetching..');

      // Check if customer is back to base collection
      const { targetCollection, originalTargetCollection } = Alpine.store('blackFridaySale').saleDetails;
      const { baseURL } = Alpine.store('URL');
      const offerCollection = '/collections/'+this.activeOffer.offer_collection;

      if (!baseURL.endsWith(offerCollection) && (baseURL.endsWith(targetCollection) || baseURL.endsWith(originalTargetCollection))) {
          // Redirect to offer collection URL
          console.log('Going to redirect: ');
          setTimeout(() => {
            window.location.href = offerCollection;
          }, 4000); // to avoid before cart upadte 
      }
    },
    get bgImage() {
      let desktopBannerImage = this.settings.desktop_banner;
      let mobileBannerImage = this.settings.mobile_banner;
      
      // if (this.activeOffer && this.activeOffer.desktop_banner_image && this.activeOffer.mobile_banner_image) {
      //   desktopBannerImage = this.activeOffer.desktop_banner_image;
      //   mobileBannerImage = this.activeOffer.mobile_banner_image;
      // }

      if (this.isStickyHeader) {
        desktopBannerImage = this.settings.desktop_sticky_header_background_image;
        mobileBannerImage = this.settings.mobile_sticky_header_background_image;
      }

      return `--bg-image-desktop: url(${desktopBannerImage}); --bg-image-mobile: url(${mobileBannerImage})`;
    },
    fontClassBySize(size) {
      const classes = {
        Small: 'text-sm md:text-base leading-4',
        Medium: 'text-base md:text-2xl leading-4',
        Large: 'text-lg md:text-3xl leading-4',
      };
      return classes[size] ? classes[size] : 'text-xl leading-4';
    },
    get activeOffer() {
      return Alpine.store('blackFridaySale').activeOffer;
    },
    get bundleItems() {
      return Alpine.store('blackFridaySale').bundleItems;
    },
    get offerItems() {
      return Alpine.store('blackFridaySale').offerItems;
    },
    get settings() {
      return Alpine.store('blackFridaySale').offerSettings;
    },
    get isStickyHeader() {
      return Alpine.store('blackFridaySale').isStickyHeader;
    }
  }));

  Alpine.data('incrementalSaleCart', () => ({
    get cartSettings() {
      return {
        body_background_color_gradient: "",
        body_background_color_solid: "#2f2f2f",
        header_background_color_gradient: "",
        header_background_color_solid: "#000000",
        header_cta_label: "Shop Now",
        name: "BF Test Cart Widget",
        offer_unlocked_sfx: "//www.loveinfaith.life/cdn/shop/files/Screenshot_2024-10-03_at_2.28.07_PM.png?v=7189000782701117905",
        primary_color_font_color: "#000000",
        primary_color_gradient: "linear-gradient(82deg, #AE8625 -5.46%, #DCC764 32.23%, #F7EF8A 54.99%, #D2AC47 91.97%, #EDC967 128.95%);",
        primary_color_solid: "",
        progress_bar_background_color: "#474747",
        secondary_font_color: "#ffffff",
      }
    },
    get offersSteps() {
      const steps = [];

      const offers = Alpine.store('incrementalSale').processSteps;
      for (let index = 0; index < offers.length; index++) {
        
        steps.push({ type: 'offer', isCompleted: offers[index], index });
        
        if (index != offers.length - 1) {
          steps.push({ type: 'separator' });
        }
      }

      return steps;
    },

    get bundleItemCount() {
      // Get completed steps
      const bundleItems = this.offersSteps.filter(s => s.isCompleted);
      return bundleItems.length;
    },

    get gradientPercentage() {

      const totalStepsCount = 5;

      // Get completed steps
      const bundleItems = this.offersSteps.filter(s => s.isCompleted);
      const numberOfBundleItems = bundleItems.length;

      // Check if No items added yet, show initial progress percentage
      if (numberOfBundleItems == 0) {
        return 2;
      }

      // Check if All offer claimed
      if (numberOfBundleItems == totalStepsCount) {
        return 100;
      }

      const extraProgress = numberOfBundleItems + 2;
      return ((numberOfBundleItems / totalStepsCount) * 100) + extraProgress;
    },
  }));

  Alpine.data('blackFridaySaleCart', () => ({
    get gradientPercentage() {
      const totalBundleItems = this.bundleItemsCount + this.offerItems.length;
      const finalExpectedBundleItemsCount = Alpine.store('blackFridaySale').highestOfferThreshold + this.offers.length;
      if (totalBundleItems == 0) {
        // No items added yet, show initial progress percentage
        return 2;
      }

      // All offer claimed
      if (this.offerItems.length == this.offers.length) {
        return 100;
      }

      // const processPercenatge = (this.offerItems.length / this.offers.length) * 100;
      const percentage = (totalBundleItems / finalExpectedBundleItemsCount) * 100;
      return percentage;
    },
    get bundleItemsCount() {
      return Alpine.store('blackFridaySale').bundleItems.length;
    },
    get settings() {
      return Alpine.store('blackFridaySale').offerSettings;
    },
    get cartSettings() {
      return this.settings.cart_widget_settings;
    },
    get offers() {
      return Alpine.store('blackFridaySale').offers;
    },
    get offerItems() {
      return Alpine.store('blackFridaySale').offerItems;
    },
    get activeOffer() {
      return Alpine.store('blackFridaySale').activeOffer;
    },
    isOfferOver(index) {
      const thisOffer = this.offers[index];

      if (this.bundleItemsCount > thisOffer.threshold) {
        return true;
      }

      return false;
    },
    isOfferActive(index) {
      const thisOffer = this.offers[index];

      if (this.bundleItemsCount == thisOffer.threshold) {
        return true;
      }

      return false;
    },
    isOfferClaimed(index) {
      return !!this.offerItems[index];
    },

    get offersSteps() {
      const steps = [];
      const { bundleItems } = Alpine.store('blackFridaySale');

      const stepsLength = 5;
      for (let index = 0; index < stepsLength; index++) {
        
        steps.push({ type: 'offer', isCompleted: !!bundleItems[index], index });
        
        if (index != stepsLength - 1) {
          steps.push({ type: 'separator' });
        }
      }

      return steps;
    },

    // get offersSteps() {
    //   const steps = [];
    //   for (let index = 0; index < this.offers.length; index++) {
    //     steps.push({ type: 'offer', offer: this.offers[index], index });
        
    //     if (index != this.offers.length - 1) {
    //       steps.push({ type: 'separator' });
    //     }
    //   }

    //   return steps;
    // },
  }));

  Alpine.data('upsellCarousel', () => ({
    isActive: false,
    settings: {},
    currentIndex: 0,
    previousIndex: null,
    flickity: null,

    init() {
      try {
        if (window.__LIF__.upsellSettings) {
          this.settings = window.__LIF__.upsellSettings;
          this.isActive = true;
        }

        this.$watch('isSideCartOpen', (open) => {
          // Check if all content is loaded
          if (open && !this.flickity) {
            setTimeout(() => {
              this.startFlickity();
            }, 100); // Let's wait to load content
          }
        }); 

        setTimeout(() => {
          if (this.isSideCartOpen && !this.flickity) {
            this.startFlickity();
          }
        }, 2000); // Let's wait to load content
      } catch(error) {
        console.error(error);
      };
    },
    get isSideCartOpen() {
      return Alpine.store('cart').isSideCartOpen;
    },
    startFlickity() {
      $('.upsell-group').removeClass('hidden');
      this.flickity = new Flickity('.upsell-group', {
        fade: true,
        imagesLoaded: true,
        contain: true,
        pageDots: false,
        cellAlign: 'left',
        draggable: false,
        groupCells: false,
        wrapAround: false,
        prevNextButtons: false,
      });
    },
    get cartProductIds() {
      return Alpine.store('cart').cartItems.map(p => p.product_id.toString());
    },

    get productChunks() {
      if(!this.isActive) {
        return [];
      }
      
      const products = this.settings.products.filter(p => !this.cartProductIds.includes(p.id.toString()));

      const chunks = [];
      const chunkSize = this.settings.tiles_per_page ? parseInt(this.settings.tiles_per_page) : 3;
      for (let i = 0; i < products.length; i += chunkSize) {
        chunks.push(products.slice(i, i + chunkSize));
      }

      // this.productChunks = 
      return chunks;
    },
    get isSlideAtEnd() {
      if(!this.isActive) {
        return false;
      }
      return this.flickity ? this.flickity.selectedIndex == this.productChunks.length : false;
    },
    get isSlideAtStart() {
      if(!this.isActive) {
        return false;
      }
      return this.flickity ? this.flickity.selectedIndex <= 1 : false;  // Avoid <template> as slide so checking 1 instead of 0
    },
    nextPage() {
      this.flickity.next();
      if (this.flickity.selectedIndex == 1) { // Avoid <template> as slide
        this.flickity.next();
      }

      console.log('this.flickity.selectedIndex: '+this.flickity.selectedIndex);
    },
    previousPage() {
      this.flickity.previous();
    }
  }));

  Alpine.data('upsellCarouselATC', () => ({
    addToCartUpsellCarousel() {
      console.log('addToCartUpsellCarousel: ');
      
      fetch(`/products/${this.product.handle}?view=quick-add`)
      .then((res) => res.text())
      .then((res) => {
        this.$refs.quickAdd.innerHTML = res;
      });
    }
  }));

  Alpine.data('buyMoreSaveMore', (handle) => ({
    isAnyOtherOfferActive: false,
    isBuyMoreActive: true,
    buyMoreDiscounts: [],
    highestDiscountQty: 12,

    init() {

      this.isAnyOtherOfferActive = isAnyOfferIsActive();

      if (this.isAnyOtherOfferActive) {
        return false;
      }

      this.$watch('isBuyMoreActive', () => {
        Alpine.store('buyMoreSaveMoreOffer').isActive = this.isBuyMoreActive;
        if (!this.isBuyMoreActive) {
          Alpine.store('buyMoreSaveMoreOffer').pdpSelectedQuantity = 1;
        }
        Alpine.store('sale').init();
      });

      this.$watch('currentDiscountPercentage', () => {
        Alpine.store('buyMoreSaveMoreOffer').currentDiscountPercentage = this.currentDiscountPercentage;
      });

      this.$watch('isHighestDiscountReached', () => {
        Alpine.store('buyMoreSaveMoreOffer').isHighestDiscountReached = this.isHighestDiscountReached;
      });

      this.$watch('buyMoreBundleItemsSplitedQty', () => {
        Alpine.store('buyMoreSaveMoreOffer').buyMoreBundleItemsSplitedQty = this.buyMoreBundleItemsSplitedQty;
      });

      if (this.buyMoreBundleItems.length > 0) {
        this.isBuyMoreActive = true;
      }

      Alpine.store('buyMoreSaveMoreOffer').isActive = this.isBuyMoreActive;
    },

    initDiscount(discounts, highestDiscountQty) {

      // this.highestDiscountQty = highestDiscountQty;

      const discountPairs = discounts.split('|');
      for (let discountPair of discountPairs) {
        const [itemCount, discountPercentage] = discountPair.split(':');

        const discount = { 
          itemCount: parseInt(itemCount),
          discountPercentage: parseFloat(discountPercentage)
        };

        this.buyMoreDiscounts.push(discount);

        // if (this.highestDiscountQty < discount.itemCount) {
        //   this.highestDiscountQty = discount.itemCount;
        // }
      }

      Alpine.store('buyMoreSaveMoreOffer').buyMoreDiscounts = this.buyMoreDiscounts;
      Alpine.store('buyMoreSaveMoreOffer').buyMoreBundleItemsSplitedQty = this.buyMoreBundleItemsSplitedQty;
    },

    get isHighestDiscountReached() {
      return this.bundleItemCount >= this.highestDiscountQty;
    },

    get upcomingDiscount() {
      return this.buyMoreDiscounts.find(d => d.itemCount > this.bundleItemCount);
    },

    get currentDiscount() {
      const lowerDiscounts = this.buyMoreDiscounts.filter(d => d.itemCount <= this.bundleItemCount);
      // select most highest qty discount
      return lowerDiscounts.pop();
    },

    get currentDiscountPercentage() {
      if (this.currentDiscount) {
        return this.currentDiscount.discountPercentage;
      }

      return 0;
    },

    get buyMoreBundleItems() {
      return Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__buy_more_bundle_item);
    },
    get buyMoreBundleItemsSplitedQty() {
      const bundleItems = [];
      for (const item of this.buyMoreBundleItems) {

        // Consider each quantity as seperate bundle item
        for(let i = 0; i < parseInt(item.quantity); i++) {
          bundleItems.push(item)
        }
      }

      return bundleItems;
    },
    get bundleItemCount() {
      // return this.buyMoreBundleItems.length;
      return this.buyMoreBundleItemsSplitedQty.length + Alpine.store('buyMoreSaveMoreOffer').pdpSelectedQuantity;
    },

    get buyMoreOfferPrice() {
      if (!this.product) {
        return null;
      }

      let finalPrice = this.product.variants[0].price / 100;

      if (this.currentDiscountPercentage) {
        const originalPrice = parseFloat(this.product.variants[0].price) / 100;
        const discount = originalPrice * this.currentDiscountPercentage / 100;
        // const discount = originalPrice * this.currentDiscountPercentage / 100;
        finalPrice =  originalPrice - discount;
      }

      return '$'+finalPrice.toFixed(2);
    }
  }));

  Alpine.data('buyMoreGetFree', (handle) => ({
    isAnyOtherOfferActive: false,
    isBuyMoreActive: false,
    highestDiscountQty: null,
    // freeItemQtyThresholds: [],

    init() {

      if (!Alpine.store('cart').hideMemberWidget) {
        this.isBuyMoreActive = true;
      }

      Alpine.store('buyMoreGetFreeOffer').isActive = this.isBuyMoreActive;

      this.$watch('isBuyMoreActive', (isActive) => {
        Alpine.store('buyMoreGetFreeOffer').isActive = isActive;
      });
    },

    initDiscount(discounts) {
      const freeItemQtyThresholds = discounts.split(',').map(d => parseInt(d));

      // Save this settting for use in other pages throughout the site
      setLifCookie('LIF-PARAMS--FREE-ITEM-QTY-THRESHOLD', JSON.stringify(freeItemQtyThresholds), 5);

      Alpine.store('buyMoreGetFreeOffer').freeItemQtyThresholds = freeItemQtyThresholds;
      Alpine.store('buyMoreGetFreeOffer').initOffer();
    },

    async addtruclassicBundleToCart(saleData, selectedQuantity) {
      console.log('addtruclassicBundleToCart: '+ selectedQuantity);
      console.log(this.selectedVariant);
      
      // debugger;
      const item = {
        id: this.selectedVariant.id,
        quantity: selectedQuantity,
        properties: {
          __member_discount_price: saleData.memberDiscount.price,
          __buy_more_get_free: {
            isActive: true,
            quantityThresholds: Alpine.store('buyMoreGetFreeOffer').freeItemQtyThresholds,
            saleName: 'Buy More Get Free'
          }
        }
      }

      this.quickAddIndex = null;

      Alpine.store('cart').addItems([item], () => {
        this.selectedQuantity = 1;
        Alpine.store('buyMoreGetFreeOffer').pdpSelectedQuantity = 1;
        Alpine.store('cart').isCartInProgress = false;
      });
    },

    async addtruclassicSingleToCart(saleData, selectedQuantity) {
      
      // debugger;
      const item = {
        id: this.selectedVariant.id,
        quantity: selectedQuantity ? selectedQuantity : 1,
        properties: {
          __member_discount_price: saleData.memberDiscount.price
        }
      }

      this.quickAddIndex = null;

      Alpine.store('cart').addItems([item], () => {
        Alpine.store('cart').isCartInProgress = false;
      });
    }
  }));

  Alpine.data('spendBasedOffer', (firstBonusSpendThreshold, secondBonusSpendThreshold) => ({
    atcInProgress: null,

    init() {
      // stay monitor if threshold met when cart total change
      this.$watch('cartTotal', (total) => {

        if (!this.hasMetFirstBonusThreshold && this.hasCartFirstFreeItem) {
          // remove free item
          const firstFreeItem = Alpine.store('cart').cartItems.find((i) => i.properties.attributes.__spend_based_offer && i.properties.attributes.__spend_based_offer.index == 1);
          if (firstFreeItem) {
            Alpine.store('cart').removeItem(firstFreeItem.key);
          }
        }

        if (!this.hasMetSecondBonusThreshold && this.hasCartSecondFreeItem) {
          // remove free item
          const secondFreeItem = Alpine.store('cart').cartItems.find((i) => i.properties.attributes.__spend_based_offer && i.properties.attributes.__spend_based_offer.index == 2);
          if (secondFreeItem) {
            Alpine.store('cart').removeItem(secondFreeItem.key);
          }
        }

      });
    },
    get cartTotal() {
      return parseFloat(Alpine.store('cart').totalPrice);
    },
    get hasMetFreeShippingThreshold() {
      return this.cartTotal >= 79;
    },
    get hasMetFirstBonusThreshold() {
      return this.cartTotal >= parseFloat(firstBonusSpendThreshold);
    },
    get hasMetSecondBonusThreshold() {
      return this.cartTotal >= parseFloat(secondBonusSpendThreshold);
    },
    get hasCartFirstFreeItem() {
      return !!Alpine.store('cart').cartItems.find((i) => i.properties.attributes.__spend_based_offer && i.properties.attributes.__spend_based_offer.index == 1);
    },
    get hasCartSecondFreeItem() {
      return !!Alpine.store('cart').cartItems.find((i) => i.properties.attributes.__spend_based_offer && i.properties.attributes.__spend_based_offer.index == 2);
    },
    get isBothFreeProductsDisplaying() {
      return this.hasMetFirstBonusThreshold && this.hasMetSecondBonusThreshold && !this.hasCartFirstFreeItem && !this.hasCartSecondFreeItem;
    },
    addToCart(variantId, index) {
      this.atcInProgress = index;

      const item = {
        id: variantId,
        quantity: 1,
        properties: {
          __spend_based_offer: { index },
          __winter_bundle_sale_fixed_price: {
            type: "FIXED",
            price: 0,
            saleName:"Buy More Get Free"
          },
        }
      };

      Alpine.store('cart').addItems([item], () => {
        this.atcInProgress = null
      });      
    }
  }));

  Alpine.data('style', (styles) => ({
    styleVars: '',
    styleClasses: '',
    init() {
      this.styleVars = '';
      this.styleClasses = '';

      for (const [key, value] of Object.entries(styles)) {
        switch(key) {
          case 'fontColor': 
            if (value) {
              this.styleVars += `--font-color:${value};`;
              this.styleClasses += ' text-[color:--font-color]';
            }
            break;
          case 'bgColor': 
            if (value) {
              this.styleVars += `--bg-color:${value};`;
              this.styleClasses += ' bg-[color:--bg-color]';
            }
            break;
          case 'bgImage': 
            if (value) {
              this.styleVars += `--bg-image:${value};`;
              this.styleClasses += ' bg-[image:--bg-image]';
            }
            break;
          case 'borderColor': 
            if (value) {
              this.styleVars += `--br-color:${value};`;
              this.styleClasses += ' border-[color:--br-color]';
            }
            break;
          case 'borderImage': 
            if (value) {
              this.styleVars += `--br-image:${value};border-image-slice: 1;`;
              this.styleClasses += ' [border-image:--br-image]';
            }
            break;
          case 'borderWidth': 
            if (value) {
              this.styleVars += `--border-width:${value}px;`;
              this.styleClasses += ' border-[length:--border-width]';
            }
            break;
          case 'borderRounded': 
            if (value) {
              this.styleVars += `--border-rounded:${value}px;`;
              this.styleClasses += ' rounded-[--border-rounded]';
            }
            break;
          case 'width': 
            if (value) {
              this.styleVars += `--width:${value};`;
              this.styleClasses += ' w-[--width]';
            }
            break;
          case 'opacity':
            if (value) {
              this.styleVars += `--opacity:${value / 100};`;
              this.styleClasses += ` opacity-[--opacity] `;
            }
        }
      }
    },
  }));

  Alpine.data('productsCarousel', (elementId) => ({
    isDragging: false,

    init() {
      const flickity = new Flickity('#'+elementId, {
        wrapAround: true,
        imagesLoaded: true
      });

      flickity.on('staticClick', function(event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex === 'number') {
          flickity.select(cellIndex);
        }
      });
    }
  }));
  
  Alpine.data('reviewImageCollection', (handle) => ({
    loadMore(ctaLink) {
      if (ctaLink) {
        window.location.href = ctaLink;
      } else {
        if (document.readyState === 'complete') {
          document.querySelector('.oke-mediaGrid-loadMore')?.click();
        } else {
          window.addEventListener('load', () => {
            document.querySelector('.oke-mediaGrid-loadMore')?.click();
          }, { once: true });
        }
      }
    }
  }));

  Alpine.data('saleHybridColorSwatch', (colorOptionPosition, colorValue, colorHax) => ({
    init() {
      // selectedOptions defined in parent component productTile
      if(this.hasSelectedThisColor) {
        this.setSelectedVariantColorCode(colorHax);
      }
    },
    get hasSelectedThisColor() {
      return this.selectedOptions[colorOptionPosition] == colorValue;
    },

    selecteThisColor(variantImage) {
      this.mainImage = variantImage;
      this.selectOption(colorOptionPosition, colorValue)
    }

  }));

  Alpine.data('flashDeal', (dealPrice) => ({
    get isFlashDealSelectedVariantOOS() {
      return this.isSelectedVariantOOS || (this.optionIndex && this.selectedOptions[this.optionIndex.size + 1] === null)
    },
    addToCartFlashDeal() {
      console.log('flashDeal ATC');
      console.log(this.selectedVariant);

      const item = {
        id: this.selectedVariant.id,
        quantity: 1,
        properties: {
          __is_flash_deal: 1,
          __winter_bundle_sale_fixed_price: {
            type: "FIXED",
            price: parseInt(dealPrice),
            saleName:"Flash Deal" 
          }
        }
      }
      Alpine.store('cart').addItems([item], () => {
        Alpine.store('cart').isCartInProgress = false;
      });
    }
  }));

  Alpine.data('placeholderImage', () => ({
    shouldImageShow: false,

    onImageLoaded() {
      console.log('onImageLoaded: ');
      this.shouldImageShow = true;
    },
    init() {
      const img = this.$refs.mainImage;

      if (!img) return;

      // 1. Listen for load event
      img.addEventListener('load', () => {
        this.showImage();
      });

      // 2. If already loaded (cached)
      if (img.complete && img.naturalWidth > 0) {
        this.showImage();
        return;
      }

      // 3. iOS Safari fallback (VERY IMPORTANT)
      setTimeout(() => {
        if (img.complete && img.naturalWidth > 0) {
          this.showImage();
        }
      }, 2000);

      // 4. Extra safety fallback
      requestAnimationFrame(() => {
        if (img.complete && img.naturalWidth > 0) {
          this.showImage();
        }
      });
    },
    showImage() {
      if (this.shouldImageShow) return;
      this.shouldImageShow = true;
      console.log("Image loaded");
    }
  }));

  Alpine.data('lifInstagram', (numberOfItems, mediaType) => ({
    instaVideos: [],
    instaRandomVideos: [],
    instaPhotos: [],
    init() {
      const accessToken = 'IGAAP8xdzN0mlBZAGFFS01UN1FHaHlTa3doTU85M3lpZAy1YSVVUT3BWVjR4YnlBNldhcE5xMnRHUlZAPSkhNSmo3TENodTZAITVc5THBDZATAzRWRybGl2eklFWUt5aHZA2MTBnT0JuWV9aUjIxQ2pZAYkxZANjV1SEgyd0RpeFRRX2twdwZDZD'; // Replace with your access token
      const limit = 100; // Number of posts to fetch
      const apiUrl = `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url&access_token=${accessToken}&limit=${limit}`;

      fetch(apiUrl)
        .then(response => response.json())
        .then(response => {
          console.log(response);
          this.instaVideos = response.data.filter(d => d.media_type == 'VIDEO').slice(0, numberOfItems);
          this.instaPhotos = response.data.filter(d => d.media_type == 'IMAGE').slice(0, numberOfItems);

          let shuffled = this.instaVideos.slice(); // create a shallow copy
          // for (let i = shuffled.length - 1; i > 0; i--) {
          //   const j = Math.floor(Math.random() * (i + 1));
          //   [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // swap
          // }
          this.instaRandomVideos = shuffled.slice(0, 5);

          // this.instaRandomVideos = this.instaVideos;

          if (this.$refs.slides) {
            setTimeout(() => {
              const flktySettings = {
                groupCells: true,
                groupCells: Alpine.store('screen').isMobile ? 1 : 5,
                cellAlign: mediaType == 'video' && Alpine.store('screen').isMobile  ? 'center' : 'left',
                // contain: true,
                // cellAlign: 'center',
                imagesLoaded: true,
              }
              const thisFlickity = new Flickity(this.$refs.slides, flktySettings);

              if (Alpine.store('screen').isMobile) {
                // Move centered element to left initially
                thisFlickity.select(1);
              }
            }, 3000);
          }
        });
      }
  }));
  
  Alpine.data('productZoom', () => ({

    open: false,
    lightboxImage: '',

    scale: 1,
    origin: 'center center',

    isDragging: false,
    hasMoved: false,

    startX: 0,
    startY: 0,
    translateX: 0,
    translateY: 0,

    touchStartX: 0,
    touchStartY: 0,
    touchEndX: 0,
    touchMoved: false,

    images: [],
    imageMap: {},
    currentIndex: 0,

    isPinching: false,
    startDistance: 0,
    startScale: 1,

    init() {
      this.images = [];
      this.imageMap = {};

      if (this.$el.dataset.images) {
        const parsed = JSON.parse(this.$el.dataset.images);

        parsed.forEach((img, index) => {
          this.images.push(img.src);
          this.imageMap[img.id] = index;

          const preload = new Image();
          preload.src = img.src;
        });
      }
    },

    get zoomStyle() {
      return `
        transform: translate3d(${this.translateX}px, ${this.translateY}px, 0) scale(${this.scale});
        transform-origin: ${this.origin};
        transition: ${this.isDragging || this.isPinching ? 'none' : 'transform .25s ease'};
      `;
    },

    openLightbox(index) {
      this.currentIndex = parseInt(index);
      this.lightboxImage = this.images[this.currentIndex];
      this.open = true;
      document.body.classList.add('overflow-hidden');
    },

    closeLightbox() {
      this.open = false;
      this.resetZoom();
      document.body.classList.remove('overflow-hidden');
    },

    /* CLICK ZOOM DESKTOP */
    handleClick(e) {
      if (this.hasMoved) return;

      const rect = e.target.getBoundingClientRect();
      
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      if (this.scale === 1) {
        this.scale = 3;
       
        this.translateX = (centerX - offsetX) * 2;
        this.translateY = (centerY - offsetY) * 2;
      
      } else {
        this.resetZoom();
      }
    },

    /* DRAG */
    startDrag(e) {
      if (this.scale === 1) return;
      
      this.isDragging = true;
      this.hasMoved = false;
     
      this.startX = e.clientX - this.translateX;
      this.startY = e.clientY - this.translateY;
    },

    drag(e) {
      if (!this.isDragging) return;
      
      this.hasMoved = true;
      
      let newX = e.clientX - this.startX;
      let newY = e.clientY - this.startY;
      
      const maxX = (this.scale - 1) * 300;
      const maxY = (this.scale - 1) * 300;
      
      this.translateX = Math.max(-maxX, Math.min(maxX, newX));
      this.translateY = Math.max(-maxY, Math.min(maxY, newY));
    },

    stopDrag() {
      this.isDragging = false;
    },

    /* TOUCH START */
    onTouchStart(e) {
      if (e.touches.length === 2) {
        this.isPinching = true;
        
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        
        this.startDistance = Math.sqrt(dx * dx + dy * dy);
        this.startScale = this.scale;
        return;
      }

      if (e.touches.length === 1) {
        const touch = e.touches[0];
        
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
        this.touchMoved = false;
        
        this.startDrag(touch);
      }
    },

    /* TOUCH MOVE */
    onTouchMove(e) {
      if (this.isPinching && e.touches.length === 2) {
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        
        const newDistance = Math.sqrt(dx * dx + dy * dy);
        const scaleChange = newDistance / this.startDistance;

        let newScale = this.startScale * scaleChange;
        newScale = Math.max(1, Math.min(newScale, 4));

        /* pinch center */
        const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

        const rect = e.target.getBoundingClientRect();

        const offsetX = centerX - rect.left;
        const offsetY = centerY - rect.top;

        const deltaScale = newScale / this.scale;

        /* adjust translate so zoom happens from pinch point */

        this.translateX -= (offsetX - rect.width / 2 - this.translateX) * (deltaScale - 1);
        this.translateY -= (offsetY - rect.height / 2 - this.translateY) * (deltaScale - 1);

        this.scale = newScale;
      }

      if (e.touches.length === 1 && this.scale > 1) {
        const touch = e.touches[0];
        
        const moveX = Math.abs(touch.clientX - this.touchStartX);
        const moveY = Math.abs(touch.clientY - this.touchStartY);
        
        if (moveX > 5 || moveY > 5) {
          this.touchMoved = true;
        }
        
        this.drag(touch);
      }
    },

    /* TOUCH END */
    onTouchEnd(e) {
      if (this.isPinching) {
        this.isPinching = false;
        return;
      }

      this.stopDrag();
      this.touchEndX = e.changedTouches[0].clientX;
      const swipeDistance = this.touchEndX - this.touchStartX;
      /* SWIPE IMAGE */
      if (Math.abs(swipeDistance) > 60 && this.scale === 1) {
        if (swipeDistance < 0) {
          this.next();
        } else {
          this.prev();
        }
        return;
      }

      /* TAP ZOOM */
      if (!this.touchMoved) {
        const touch = e.changedTouches[0];
        const rect = e.target.getBoundingClientRect();
        const offsetX = touch.clientX - rect.left;
        const offsetY = touch.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        if (this.scale === 1) {
          this.scale = 3;
          this.translateX = (centerX - offsetX) * 2;
          this.translateY = (centerY - offsetY) * 2;
        } else {
          this.resetZoom();
        }
      }
    },

    toggleZoomButton() {
      if (this.scale === 1) {
        this.scale = 3;
      } else {
        this.resetZoom();
      }
   },
   
    resetZoom() {
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
      this.origin = 'center center';
      this.hasMoved = false;
    },

    next() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.lightboxImage = this.images[this.currentIndex];
      this.resetZoom();
    },

    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.lightboxImage = this.images[this.currentIndex];
      this.resetZoom();
    }

  }));
});